module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("By ")]), _vm._v("B"), _c('span', {
    staticClass: "t8"
  }, [_vm._v("RANDON")]), _vm._v(" W"), _c('span', {
    staticClass: "t8"
  }, [_vm._v("ITT")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Grand Adventures (Dreamspinner anthology)")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("The Shattered Door")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Then the Stars Fall")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("EN")]), _c('span', {
    staticClass: "t9"
  }), _c('span', {
    staticClass: "t10"
  }, [_vm._v("OF")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v(" M")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("YTH")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Submerging Inferno")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Rising Frenzy")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Clashing Tempest")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Published by ")]), _vm._v("D"), _c('span', {
    staticClass: "t8"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" P"), _c('span', {
    staticClass: "t8"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("http://www.dreamspinnerpress.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad4a8b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003.vue
// module id = 60
// module chunks = 0